module.exports = __webpack_public_path__ + "9f31482480ccdb7658804b0ee50bb73d.m4a";


//////////////////
// WEBPACK FOOTER
// ./src/components/InteractiveExample/de/5.m4a
// module id = 974
// module chunks = 4